import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f7371d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "finding-value flex flex-grow align-center"
}
const _hoisted_3 = {
  key: 0,
  class: "under-threshold"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jet" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "current-wrapper"
}
const _hoisted_6 = ["title"]

import IbIcons from "@/components/icons/ib-icons.vue";
import { Insight } from '@/models/insight';
import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Likelihood',
  props: {
  insight: {
    type: Object as PropType<Insight>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const carretPosition = computed(() => {
  if (props.insight.value) {
    const value: number = parseInt((props.insight.value * 100).toFixed(0))
    return {
      'clip-path': `polygon(${value - 2}% 0%, ${value - 2}% 100%, ${value + 2}% 100%, ${value + 2}% 0%)`
    }
  }
})

const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "finding-likelihood flex flex-grow align-center",
    title: props.insight.value == 0 ? _unref(t)('insights.low_threshold') : ''
  }, [
    _createVNode(IbIcons, {
      icon: "ai",
      size: "14",
      class: "ai-icon"
    }),
    (!isNaN(parseFloat(props.insight.value)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (props.insight.value == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          _hoisted_4,
          (props.insight.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  style: _normalizeStyle(_unref(carretPosition)),
                  class: "current"
                }, null, 4)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex-grow na",
          title: _unref(t)('insights.not_calculated')
        }, _toDisplayString(_unref(t)('insights.na')), 9, _hoisted_6))
  ], 8, _hoisted_1))
}
}

})